import React, { useState } from "react";
import {
  DEFAULT_C,
  screenStyle,
  cardStyle,
  primaryButtonStyle,
} from "./authStyles.js";

export default function BetaCodeGate({ onSubmit, onLogout, C = DEFAULT_C, logo = null }) {
  const [code, setCode] = useState("");
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);

  const submit = async (event) => {
    event.preventDefault();
    setError(null);
    setLoading(true);
    try {
      await onSubmit(code.trim());
    } catch (err) {
      setError(err?.message || "Invalid beta code.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={screenStyle(C)} data-testid="beta-code-screen">
      {logo}
      <h1
        style={{
          fontFamily: "Lora, Georgia, serif",
          fontSize: 32,
          fontWeight: 700,
          color: C.white,
          margin: "8px 0 8px",
        }}
      >
        Enter beta code
      </h1>
      <p style={{ color: "rgba(255,255,255,.78)", fontSize: 14, lineHeight: 1.6, maxWidth: 420, marginBottom: 24 }}>
        Your identity is verified. Add your beta code to unlock saved meals and preferences.
      </p>

      <form onSubmit={submit} style={{ ...cardStyle, gap: 12 }}>
        <input
          type="text"
          placeholder="Beta code"
          value={code}
          onChange={e => { setCode(e.target.value); setError(null); }}
          autoCapitalize="characters"
          required
          style={{
            padding: "14px 16px",
            borderRadius: 12,
            border: "none",
            fontSize: 15,
            fontFamily: "inherit",
            outline: "none",
            background: "rgba(255,255,255,.9)",
            color: C.charcoal,
            letterSpacing: 0,
          }}
        />
        {error && (
          <p style={{ color: "#ffcdd2", fontSize: 13, margin: 0 }} role="alert">
            {error}
          </p>
        )}
        <button
          type="submit"
          disabled={loading || !code.trim()}
          style={{
            ...primaryButtonStyle(C),
            opacity: loading || !code.trim() ? 0.65 : 1,
            cursor: loading || !code.trim() ? "default" : "pointer",
          }}
          data-testid="beta-code-submit"
        >
          {loading ? "Checking..." : "Continue"}
        </button>
      </form>

      <button
        type="button"
        onClick={onLogout}
        style={{
          marginTop: 24,
          background: "none",
          border: "none",
          color: "rgba(255,255,255,.62)",
          fontSize: 13,
          textDecoration: "underline",
          cursor: "pointer",
          fontFamily: "inherit",
        }}
        data-testid="beta-code-logout"
      >
        Use a different account
      </button>
    </div>
  );
}
